import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\DraftReservationController::index
* @see app/Http/Controllers/Admin/DraftReservationController.php:22
* @route '/admin/draft-reservations'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/draft-reservations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::index
* @see app/Http/Controllers/Admin/DraftReservationController.php:22
* @route '/admin/draft-reservations'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::index
* @see app/Http/Controllers/Admin/DraftReservationController.php:22
* @route '/admin/draft-reservations'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::index
* @see app/Http/Controllers/Admin/DraftReservationController.php:22
* @route '/admin/draft-reservations'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::show
* @see app/Http/Controllers/Admin/DraftReservationController.php:144
* @route '/admin/draft-reservations/{uuid}'
*/
export const show = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/admin/draft-reservations/{uuid}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::show
* @see app/Http/Controllers/Admin/DraftReservationController.php:144
* @route '/admin/draft-reservations/{uuid}'
*/
show.url = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { uuid: args }
    }

    if (Array.isArray(args)) {
        args = {
            uuid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        uuid: args.uuid,
    }

    return show.definition.url
            .replace('{uuid}', parsedArgs.uuid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::show
* @see app/Http/Controllers/Admin/DraftReservationController.php:144
* @route '/admin/draft-reservations/{uuid}'
*/
show.get = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::show
* @see app/Http/Controllers/Admin/DraftReservationController.php:144
* @route '/admin/draft-reservations/{uuid}'
*/
show.head = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::sendReminder
* @see app/Http/Controllers/Admin/DraftReservationController.php:186
* @route '/admin/draft-reservations/{uuid}/send-reminder'
*/
export const sendReminder = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendReminder.url(args, options),
    method: 'post',
})

sendReminder.definition = {
    methods: ["post"],
    url: '/admin/draft-reservations/{uuid}/send-reminder',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::sendReminder
* @see app/Http/Controllers/Admin/DraftReservationController.php:186
* @route '/admin/draft-reservations/{uuid}/send-reminder'
*/
sendReminder.url = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { uuid: args }
    }

    if (Array.isArray(args)) {
        args = {
            uuid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        uuid: args.uuid,
    }

    return sendReminder.definition.url
            .replace('{uuid}', parsedArgs.uuid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::sendReminder
* @see app/Http/Controllers/Admin/DraftReservationController.php:186
* @route '/admin/draft-reservations/{uuid}/send-reminder'
*/
sendReminder.post = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendReminder.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::destroy
* @see app/Http/Controllers/Admin/DraftReservationController.php:249
* @route '/admin/draft-reservations/{uuid}'
*/
export const destroy = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin/draft-reservations/{uuid}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::destroy
* @see app/Http/Controllers/Admin/DraftReservationController.php:249
* @route '/admin/draft-reservations/{uuid}'
*/
destroy.url = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { uuid: args }
    }

    if (Array.isArray(args)) {
        args = {
            uuid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        uuid: args.uuid,
    }

    return destroy.definition.url
            .replace('{uuid}', parsedArgs.uuid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::destroy
* @see app/Http/Controllers/Admin/DraftReservationController.php:249
* @route '/admin/draft-reservations/{uuid}'
*/
destroy.delete = (args: { uuid: string | number } | [uuid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::bulkDelete
* @see app/Http/Controllers/Admin/DraftReservationController.php:277
* @route '/admin/draft-reservations/bulk-delete'
*/
export const bulkDelete = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkDelete.url(options),
    method: 'post',
})

bulkDelete.definition = {
    methods: ["post"],
    url: '/admin/draft-reservations/bulk-delete',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::bulkDelete
* @see app/Http/Controllers/Admin/DraftReservationController.php:277
* @route '/admin/draft-reservations/bulk-delete'
*/
bulkDelete.url = (options?: RouteQueryOptions) => {
    return bulkDelete.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DraftReservationController::bulkDelete
* @see app/Http/Controllers/Admin/DraftReservationController.php:277
* @route '/admin/draft-reservations/bulk-delete'
*/
bulkDelete.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkDelete.url(options),
    method: 'post',
})

const draftReservations = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    sendReminder: Object.assign(sendReminder, sendReminder),
    destroy: Object.assign(destroy, destroy),
    bulkDelete: Object.assign(bulkDelete, bulkDelete),
}

export default draftReservations